const CheckExistence = async (value, baseURL, setEmailExistence) => {
  await fetch(`${baseURL}${value}`)
    .then((response) => {
      // Check if the response status is OK (200)
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.text();
    })
    .then((data) => {
      setEmailExistence(data);
      return data;
    })
    .catch((error) => {
      console.error("Fetch error:", error);
    });
};

export default CheckExistence;
